module.exports = __webpack_public_path__ + "static/hrb-logo-45942e314d99d7e1fbd341a53ad68d4b.png";